import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  button: {
    width: '100px',
  },
}));

export default useStyles;
